import styled from "styled-components";
import bg1 from "./assets/Graphics/bg1.png";

export const FormContainer = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 800px;

  /* padding: 10px; */
  h3 {
    /* align-self: center; */
    font-family: ${(props) =>
    props.lang === "fa" ? "Tanha, sans-serif" : "Purisa, sans-serif"};
    font-size: clamp(20px, 2.2vw, 5em);
    text-align: center;
    padding: 0.3em 0;
    /* text-transform: uppercase; */
    letter-spacing: -1px;

    background-image: url(${bg1});
    background-size: contain;
    /* background-size: auto; */
    /* background-size: 60%; */
    background-repeat: no-repeat;
    background-position: center;
    /* background-color: red; */
    margin: 0.5em 0;
  }
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.7rem;
  width: 100%;
  padding: 0.5rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

export const Input = styled.input`
  flex: 1;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  color: #333;

  &::placeholder {
    font-size:18px;
    opacity:0.7;
    font-family: ${(props) => props.lang === "fa" ? "Tanha, sans-serif" : "Purisa, sans-serif"};
    text-align: ${(props) => props.lang === "fa" ? "right" : "left"};
    }
  &[type="email"] {
    text-align:left;
  }
  font-family: ${(props) =>
    props.lang === "fa" ? "Tanha, sans-serif" : "Purisa, sans-serif"};
  &:focus {
    border-color: ${(props) => props.theme.colors.colorbg};
    outline: none;
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  color: #333;
  /* padding: 10px; */
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  resize: vertical;
  &::placeholder {
    font-size:18px;
    opacity:0.7;
    font-family: ${(props) => props.lang === "fa" ? "Tanha, sans-serif" : "Purisa, sans-serif"};
    text-align: ${(props) => props.lang === "fa" ? "right" : "left"};
  }
  font-family: ${(props) =>
    props.lang === "fa" ? "Tanha, sans-serif" : "Purisa, sans-serif"};
  &:focus {
    border-color: ${(props) => props.theme.colors.colorbg};
    outline: none;
  }
`;
